function revealInitialHidden(e) {
  const trigger = e.currentTarget;
  const revealContainer = trigger.parentNode.querySelector('.js-initial-hidden');
  revealContainer.style.maxHeight = revealContainer.scrollHeight + 'px';
  trigger.classList.add('is-hidden');

  setTimeout(() => {
    revealContainer.classList.add('is-visible');
    revealContainer.style.maxHeight = '';
  }, 400);
}
